import * as type from '../types'
import {ActionType} from 'Interfaces'

export const getCandidateCompleteness = (): ActionType<undefined> => {
  return {
    type: type.candidate.completeness.requested,
  }
}
